"use client";

import { useEffect } from "react";
import { trackEvent } from "@/lib/analytics";

const SECTION_IDS = [
  "old-way",
  "meet",
  "how-it-works",
  "use-cases",
  "impact",
  "compliance",
  "faq",
  "demo",
];

/** Fires one PostHog event per landing section the first time it becomes visible. */
export default function SectionViewTracker() {
  useEffect(() => {
    const seen = new Set<string>();
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const id = entry.target.id;
          if (entry.isIntersecting && !seen.has(id)) {
            seen.add(id);
            trackEvent("landing_section_viewed", { section: id });
            io.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.4 },
    );
    SECTION_IDS.forEach((id) => {
      const el = document.getElementById(id);
      if (el) io.observe(el);
    });
    return () => io.disconnect();
  }, []);
  return null;
}
